import { Component, OnInit } from "@angular/core"
import { ActivatedRoute, Params } from "@angular/router"

import { DisplayService } from "../../display.service"
import { ReferralService } from "../referral.service"

@Component({
  selector: "app-merchant-terms",
  templateUrl: "./merchant-terms.component.html",
  styleUrls: ["./merchant-terms.component.scss"]
})
export class ReferralMagicMerchantTermsComponent implements OnInit {
  // Local variables
  is_enabled: boolean
  merchant_terms: string
  text_color: string

  constructor(
    private displayService: DisplayService,
    private referralService: ReferralService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.forEach((params: Params) => {
      this.displayService.is_embedded = params.hasOwnProperty("embed")
      this.displayService.setModal(params.hasOwnProperty("modal"))
    })
    this.route.params.forEach((params: Params) => {
      const merchant_slug = params["merchant_slug"]
      this.referralService
        .getMerchant(merchant_slug)
        .then(
          (merchant) => {
            if (
              merchant.settings.referral_magic &&
              merchant.settings.referral_magic.enabled &&
              merchant.referral_program
            ) {
              this.displayService.setReferralMagicPageStyles(merchant.referral_program.pages)
              this.text_color = merchant.referral_program.pages.colors.text
              this.is_enabled = true
              this.referralService.getMerchantTerms(merchant_slug).then(
                (merchant_terms) =>
                  (this.merchant_terms = this.referralService.replaceDynamicValues(merchant_terms, merchant)),
                (error) => {
                  // @todo
                }
              )
            } else {
              this.is_enabled = false
            }
          },
          (error) => {
            // @todo
          }
        )
        .then(() => {
          this.displayService.setApplicationLoaded()
        })
    })
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/referral-magic/merchant-terms/merchant-terms.component.ts